module.exports = __webpack_public_path__ + "media/icons/naped-przod-white-1dbfc3ec.png";